export enum EmailEnum {
  customerRulesSupport = 'SpeedyG-Feedback@xpo.com',
}

export enum EmailValidationRegexPatterns {
  emailValidationPattern = "^[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$",
}